module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("dcxnF"))).then(() => parcelRequire('8rm4T'));